import { Backdrop, Box, Button, CircularProgress, Divider, FormControl, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material"
import Popup from "../../../Base/views/Popup"
import { ConvertDate, DateConvertInDbFormat } from "../../../Base/helper/baseFunctions";
import { useSelector } from "react-redux";
import { pdf } from "@react-pdf/renderer";
import AtsInvoicePdf from "./AtsInvoicePdf";
import { CSVLink } from "react-csv";
import { useEffect, useState } from "react";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";

const ATSGeneratedInvoicePopup = ({ setShowGeneratedInvoice, currentData, companylogo, letterHeadData, handlePaidStatus = () => {} }) => {
    const { invoiceCandidateData, isCandidateLoading } = useSelector(state => state.AtsReducer?.AtsInvoiceReducer)
    const { company_config_data } = useSelector((state) => state?.AncillaryReducer?.CompanyConfigReducer);
    const [isPdfGenerating, setIsPdfGenerating] = useState(false);
    const handleDownloadPDF = async () => {
        setIsPdfGenerating(true);
        const MyDocument = (
            <AtsInvoicePdf
                data={currentData}
                invoiceCandidateData={invoiceCandidateData}
                companylogo={companylogo}
                letterHeadData={letterHeadData}
                orgConfigData={company_config_data}
            />
        );

        const blob = await pdf(MyDocument).toBlob();
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `${currentData?.ats_invoice_no}.pdf`;
        a.click();
        // Clean up the URL object
        URL.revokeObjectURL(url);
        setIsPdfGenerating(false);
    };

    const headers = [
        { label: "Candidate Name", key: "first_name" },
        { label: "Job Title", key: "job_title" },
        { label: "Job Location", key: "job_location" },
        { label: "Joined Date", key: "joined_date" },
        { label: "Billable CTC", key: "billable_ctc" },
        { label: "Billable Amount", key: "amount" },
    ];
    const [editableData, setEditableData] = useState({
        paid_date: currentData?.paid_date || DateConvertInDbFormat(),
        received_amount: currentData?.received_amount || "",
        tds_amount: currentData?.tds_amount || ""
    });
    useEffect(() => {
        if (currentData?.isEditable) {
            setEditableData({
                ...currentData,
                paid_date: currentData?.paid_date ||  DateConvertInDbFormat(),
                received_amount: currentData?.received_amount || "",
                tds_amount: currentData?.tds_amount || ""
            });
        }
    }, [currentData]);
    const final_invoice_amount = safeNumber(currentData?.gst_breakup?.candidate_total) + safeNumber(currentData?.gst_total) + safeNumber(editableData?.tds_amount);
    
    const handleConfirm = () => {
        handlePaidStatus("Paid", {...editableData, final_invoice_amount});
    }

    return (
        <>
            <Popup
                title={`${currentData?.ats_invoice_no}`}
                openPopup={true}
                setOpenPopup={setShowGeneratedInvoice}
                maxWidth={"md"}
                fullWidth={true}
            >
                {
                    isCandidateLoading &&
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={true}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                }
                <Box>
                    <Box>
                        <Grid container>
                            <Grid item xs={12} sm={8}>
                                <Box sx={{ display: 'flex', alignItems: 'start' }}>
                                    <Typography sx={{ fontWeight: "bold", minWidth: '100px' }}>Bill To</Typography>
                                    <Typography sx={{ ml: 2 }}>{currentData?.billing_name}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'start' }}>
                                    <Typography sx={{ fontWeight: "bold", minWidth: '100px' }}>Billing Address</Typography>
                                    <Typography sx={{ ml: 1.7 }}>{currentData?.billing_address}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'start' }}>
                                    <Typography sx={{ fontWeight: "bold", minWidth: '100px' }}>GST No.</Typography>
                                    <Typography sx={{ ml: 2 }}>{currentData?.gst_number || "NA"}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Box sx={{ display: 'flex', alignItems: 'start' }}>
                                    <Typography sx={{ fontWeight: "bold", minWidth: '110px' }}>Invoice Date</Typography>
                                    <Typography sx={{ mr: 2 }}>{ConvertDate(currentData?.invoice_date)}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'start' }}>
                                    <Typography sx={{ fontWeight: "bold", minWidth: '110px' }}>Invoice No</Typography>
                                    <Typography sx={{ mr: 2 }}>{currentData?.ats_invoice_no}</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                   {!currentData?.isEditable && <Box sx={{ display: "flex", justifyContent: "flex-end", m: 1 }}>
                        {!isCandidateLoading &&
                            <>
                                <Button className="mpl-primary-btn" onClick={handleDownloadPDF} disabled={isPdfGenerating} startIcon={isPdfGenerating ? <CircularProgress size={18} disableShrink color="inherit" /> : null}>
                                    Download PDF
                                </Button>
                                <Button sx={{ ml: 2 }} className="mpl-primary-btn">
                                    <CSVLink className="ats-csv-btn" data={invoiceCandidateData} headers={headers} filename={currentData?.ats_invoice_no}>
                                        Download CSV
                                    </CSVLink>
                                </Button>
                            </>}
                    </Box>}
                    <Box>
                        <TableContainer>
                            <Table sx={{ minWidth: 650 }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Candidate Name</TableCell>
                                        <TableCell>Job Title</TableCell>
                                        <TableCell>Job Location</TableCell>
                                        <TableCell>Joined Date</TableCell>
                                        <TableCell align="center">Joined CTC</TableCell>
                                        <TableCell align="center">Billable CTC</TableCell>
                                        <TableCell align="center">Billable Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {invoiceCandidateData?.map((row) => (
                                        <TableRow
                                            key={row.name}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell>{`${row?.first_name} ${row?.last_name}`}</TableCell>
                                            <TableCell>{row?.job_title}</TableCell>
                                            <TableCell>{row?.job_location}</TableCell>
                                            <TableCell>{row?.joined_date ? ConvertDate(row?.joined_date) : ""}</TableCell>
                                            <TableCell align="center">{formatAmount(row?.joined_ctc)}</TableCell>
                                            <TableCell align="center">{formatAmount(row?.billable_ctc)}</TableCell>
                                            <TableCell align="center">{formatAmount(row?.amount)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box sx={{ mt: 2, display: "flex", justifyContent: (currentData?.isEditable || currentData?.tabSection === "settled")? "space-between" : "flex-end" }}>
                     {/* ---- Active Invoice Generated Section */}
                     {currentData?.isEditable && (
                        <Grid container spacing={2} pt={1}>
                            <Grid item>
                                <FormControl fullWidth >
                                    <CommonDatePicker
                                        size="small"
                                        name="paid_date"
                                        label="Paid Date"
                                        pickerType="date"
                                        pickerFormat="dd/MM/yyyy"
                                        DefaultDTvalue={editableData?.paid_date}
                                        maxDate={new Date()}
                                        handleChange={(value) => {
                                            setEditableData({
                                                ...editableData,
                                                paid_date: value
                                                    ? `${value.getFullYear()}-${("0" + (value.getMonth() + 1)).slice(-2)}-${("0" + value.getDate()).slice(-2)}`
                                                    : "",
                                            });
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item>
                                <TextField
                                    size="small"
                                    fullWidth
                                    label="Received Amount"
                                    value={editableData?.received_amount}
                                    onChange={(e) =>
                                        setEditableData({
                                            ...editableData,
                                            received_amount: e.target.value,
                                        })
                                    }
                                />
                            </Grid>
                            <Grid item>
                                <TextField
                                    size="small"
                                    fullWidth
                                    label="TDS"
                                    value={editableData?.tds_amount}
                                    onChange={(e) =>
                                        setEditableData({
                                            ...editableData,
                                            tds_amount: e.target.value,
                                        })
                                    }
                                />
                            </Grid>
                        </Grid>
                     )}
                    {/* ---Closed Invoice Settled Section---- */}
                    {currentData?.tabSection === "settled" && (
                        <Grid container spacing={2} pt={1}>
                            <Grid item>
                                <Box display={"flex"} alignItems={"center"} gap={1}>
                                    <Typography fontWeight="bold">
                                        Paid Date:
                                    </Typography>
                                    <Typography>
                                        {editableData?.paid_date
                                        ? ConvertDate(editableData?.paid_date)
                                        : "NA"}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box display={"flex"} alignItems={"center"} gap={1}>
                                    <Typography fontWeight="bold">
                                        Received Amount:
                                    </Typography>
                                    <Typography>
                                        {formatAmount(editableData?.received_amount)}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    )}

                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                            <Typography sx={{ minWidth: '120px' }}>Invoice Amount&nbsp;</Typography>
                            <Typography sx={{ mr: 1, textAlign: "right" }}>{currentData?.gst_breakup?.candidate_total || 0}</Typography>
                        </Box>
                        {Number(currentData?.tds_percentage) > 0 && (
                            // Show TDS if available
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <Typography sx={{ minWidth: "120px" }}>TDS</Typography>
                                <Typography sx={{ mr: 1 , textAlign: "right"}}>{formatAmount(editableData?.tds_amount)}</Typography>
                            </Box>
                        )}
                        {currentData?.gst_breakup?.gst_applicable && (
                        <>
                            {Number(currentData?.gst_breakup?.igst) > 0 ? (
                                // Show IGST if available
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <Typography sx={{ minWidth: "120px" }}>IGST&nbsp;-&nbsp;{currentData?.gst_breakup?.igst || 0}%</Typography>
                                    <Typography sx={{ mr: 1 , textAlign: "right"}}>{currentData?.gst_breakup?.igst_total || 0}</Typography>
                                </Box>
                            ) : (
                              <>
                                <Box sx={{ display: 'flex', alignItems: 'center',justifyContent: "space-between", }}>
                                    <Typography sx={{ minWidth: '120px' }}>CGST&nbsp;-&nbsp;{currentData?.gst_breakup?.cgst || 0}%</Typography>
                                    <Typography sx={{ mr: 1, textAlign: "right" }}>{currentData?.gst_breakup?.cgst_total || 0}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", }}>
                                    <Typography sx={{ minWidth: '120px' }}>SGST&nbsp;-&nbsp;{currentData?.gst_breakup?.sgst || 0}%</Typography>
                                    <Typography sx={{ mr: 1, textAlign: "right" }}>{currentData?.gst_breakup?.sgst_total || 0}</Typography>
                                 </Box>
                              </>
                            )}
                        </>
                        )}
                        <Divider sx={{ fontWeight: "bold" }} />
                        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, justifyContent: "space-between", }}>
                            <Typography sx={{ fontWeight: "bold", minWidth: '120px' }}>Total Amount&nbsp;</Typography>
                            <Typography sx={{ mr: 1, textAlign: "right" }}>{formatAmount(final_invoice_amount) || 0}</Typography>
                        </Box>
                    </Box>
                    </Box>
                    {currentData?.isEditable &&
                        <Box display={"flex"} justifyContent={"flex-end"} pt={2}>
                            <Button
                                variant="contained"
                                size="small"
                                className='mpl-primary-btn'
                                onClick={handleConfirm}
                            >
                                Confirm
                            </Button>
                        </Box>
                    }
                </Box>
            </Popup >
        </>
    )
}
const formatAmount = (value) => {
  const num = Number(value);
  return isNaN(num) ? "0.00" : num?.toFixed(2);
};
const safeNumber = (value) => {
  const num = Number(value);
  return isNaN(num) ? 0 : num;
};

export default ATSGeneratedInvoicePopup